<form [formGroup]="uploadForm" name="form__{{ idx }}" class="d-flex flex-wrap upload-product-group">
  <ng-container formArrayName="fileImages">
    <ng-container *ngIf="fileImages && fileImages.length">
      <div
        *ngFor="let img of fileImages.controls; index as i"
        class="dropzone position-relative col-lg-4"
      >
        <span class="img-close-icon position-absolute top-0 end-0 p-3" [inlineSVG]="STRING_CONSTANTS.ICON.IC_BULLET_CLOSE"
              (click)="onDeleteFileImage(i,  img.value )"></span>
        <img [formGroupName]="i" [src]="img.value.url" class="img-fluid" [alt]="'preview__'+i" style="max-height: 100%;" />
      </div>
    </ng-container>

    <ng-container *ngIf="fileImages.length < maxLimit">
      <div
        class="dropzone position-relative" appDnd
        [ngStyle]="{height:'176x', width : '176px'}"
        (filesChangeEmitter)="handleDropFiles($event)"
        style="{{ isLoading.value ? 'pointer-events: none;' : '' }}"
      >
        <ng-container *ngTemplateOutlet="loadingUpload"></ng-container>
        <label
          for="fileImages__{{ idx }}"
          class="d-flex cursor-pointer align-items-center justify-content-center flex-column"
          style="{{ isLoading.value ? 'opacity: 0.25' : '' }}"
        >
          <span [inlineSVG]="STRING_CONSTANTS.ICON.IC_PLUS_DISABLED" class="svg-icon"></span>
          <span class="mt-4 text-gray-400">Add image here</span>
        </label>

        <input
          id="fileImages__{{ idx }}"
          name="fileImages__{{ idx }}"
          type="file" accept="image/*"
          multiple
          class="d-none"
          (change)="onFileSelected($event)"
        />
      </div>
    </ng-container>
  </ng-container>
</form>

<ng-template #loadingUpload>
  <span
    *ngIf="isLoading.value"
    class="indicator-progress d-flex align-items-center justify-content-center position-absolute mb-8">
    <span class="spinner-border spinner-border-md align-middle"></span>
  </span>
</ng-template>
